export class ChartEnvironment {
  public static getName = () => 'benzinga-chart';
  public static getEnvironment = (env: Record<string, string>) => ({
    barsKey: env.barsKey ?? 'a95054f9f5ce46698a0f4e388e487113',
    barsUrl: new URL(env.barsUrl ?? 'https://api.benzinga.com/api/'),
    cryptoUrl: new URL(env.cryptoUrl ?? 'https://www.benzinga.com/'),
    embedChartUrl: env.embedChartUrl ?? 'https://widgets.benzinga.com/',
    key: env.key ?? 'aH0FkLCohY5yxK6OEaJ28Zpv51Ze1GyY',
    socketUrl: new URL(env.socketUrl ?? 'wss://pro-charts.benzinga.com/quotes/socket'),
    url: new URL(env.url ?? 'https://data-api-pro.benzinga.com/rest/'),
  });
}
